export const consultationOrderDetailEn = {
    zxzjlx:"Type of consultant",
    zxje:"Consulting amount",
    goumaiguige:'Purchase specification',
    zhixunyouxqzhi:'Consultation valid until'
}


// WEBPACK FOOTER //
// ./src/lang/home/consultationOrderDetail/indexEn.js